import { Text, View } from 'react-native'
import { convertLineHeight, styled } from '~/utils'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: theme.spacingInlineOnepulse,
      backgroundColor: 'transparent',
      paddingHorizontal: theme.paddingInsetOnepulse,
      paddingTop: theme.spacingInlineHalfpulse,
    },
    variants: {},
  }
})

export const Label = styled(Text, theme => {
  return {
    base: {
      fontFamily: theme.fontFamily.semiBold,
      fontSize: theme.fontSizeThreepulse,
      color: theme.colorTextNeutralAlternative,
      flexShrink: 1,
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      hasError: {
        true: {
          color: theme.colorTextDangerAlternative,
        },
      },
      disabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      readonly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          disabled: true,
          readonly: true,
        },
        css: {
          color: theme.colorTextNeutralDisabled,
        },
      },
    ],
  }
})
